import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DcBaseComponent } from '@datachain/ui-sdk/common';
import { AppModalService } from '@datachain/ui-sdk/components/app-modal';

import { configuration } from '../../../core/configuration';
import { DcIcons } from '../../app-dc.icons';
import { ValidationErrorKeys } from '../../form/validation-erros-keys';

export interface ISendEmailOutput {
	title: string;
	message: string;
}
export enum SendEmailFormControls {
	Title = 'title',
	Message = 'message',
}
@Component({
	selector: 'app-send-email-popup',
	templateUrl: './send-email-popup.component.html',
	styleUrls: ['./send-email-popup.component.scss'],
})
export class SendEmailPopupComponent extends DcBaseComponent {
	protected readonly DcIcons = DcIcons;
	protected readonly ValidationErrorKeys = ValidationErrorKeys;
	protected readonly configuration = configuration;
	public form: FormGroup;
	protected readonly SendEmailFormControls = SendEmailFormControls;
	public constructor(
		private readonly modalService: AppModalService,
		protected readonly fb: FormBuilder
	) {
		super();
		this.cmpId = 'send-email-popup';
		this.form = this.fb.group({
			[SendEmailFormControls.Title]: [
				'',
				[
					Validators.required,
					Validators.maxLength(configuration.maxLengthProjectEmailTitle),
				],
			],
			[SendEmailFormControls.Message]: [
				'',
				[
					Validators.required,
					Validators.maxLength(configuration.maxLengthProjectEmailMessage),
				],
			],
		});
	}

	public sendEmail(): void {
		const formValues = this.form.value;
		this.modalService.closeActiveModal({
			title: formValues[SendEmailFormControls.Title] ?? '',
			message: formValues[SendEmailFormControls.Message] ?? '',
		});
	}
}
